import { Button, Modal } from "@shapr3d/frontend-lib";

import style from "./ARNotSupportedModal.module.css";

interface ARNotSupportedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ARNotSupportedModal: React.FC<ARNotSupportedModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal open={isOpen} onClose={onClose} size="small" persistent>
      <div className={style.container}>
        <div className={style.title}>Augmented Reality Preview Unavailable</div>
        <div className={style.text}>
          {`This AR preview can\u2019t be displayed.`}
          <br />
          {`Try a different browser, or check if your device and available memory support Augmented Reality.`}
        </div>
        <Button variant="primary" onClick={onClose} className={style.button}>
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default ARNotSupportedModal;
